<div id="editor" [style.height]="height"></div>